/* AagamStuti search and filter extras. Plain JavaScript, no libraries. Linked by the header section, after aagamstuti.js.
   Search sheet: richer suggestions (searches, collections, products), recent searches, arrow keys and "In stock".
   Filters: the "In stock" switch and the price-band chips drive the filter form that aagamstuti.js already runs.
   Speed: a product page is fetched early when a pointer or finger lands on its link.
   Screen readers: one short count is announced for the suggestions, not the whole list. */
(function () {
  'use strict';
  if (window.__asSearchBoot) return;
  window.__asSearchBoot = true;

  var doc = document;
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function store(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      if (val === null) localStorage.removeItem(key); else localStorage.setItem(key, val);
    } catch (e) {}
    return null;
  }

  /* ---------- Suggestions: ask for searches and collections as well, cancel stale requests, remember answers ---------- */
  var origFetch = window.fetch;
  if (origFetch && window.AbortController && window.Response) {
    var ctl = null, cache = {}, order = [];
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/search/suggest') === -1 || url.indexOf('section_id=predictive-search') === -1) return origFetch.apply(this, arguments);
      var full = url.replace('resources[type]=product', 'resources[type]=product,collection,query').replace(/resources\[limit\]=\d+/, 'resources[limit]=6') + '&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      var box = $('[data-search-results]');
      if (cache[full]) {
        if (box) box.classList.remove('is-loading');
        return Promise.resolve(new Response(cache[full], { status: 200, headers: { 'Content-Type': 'text/html' } }));
      }
      if (ctl) ctl.abort();
      var mine = ctl = new AbortController();
      if (box) box.classList.add('is-loading');
      return origFetch.call(this, full, { signal: mine.signal }).then(function (res) {
        if (mine === ctl && box) box.classList.remove('is-loading');
        if (res.ok) {
          res.clone().text().then(function (t) {
            if (cache[full]) return;
            cache[full] = t; order.push(full);
            if (order.length > 30) delete cache[order.shift()];
          });
        }
        return res;
      }, function (err) {
        if (mine === ctl && box) box.classList.remove('is-loading');
        throw err;
      });
    };
  }

  /* ---------- Recent searches ---------- */
  var RKEY = 'as-recent';
  function recents() {
    var list = [];
    try { list = JSON.parse(store(RKEY) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) return [];
    return list.filter(function (x) { return typeof x === 'string' && x; }).slice(0, 6);
  }
  function remember(q) {
    q = String(q || '').trim();
    if (q.length < 2 || q === '*') return;
    var list = recents().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    store(RKEY, JSON.stringify(list.slice(0, 6)));
  }
  function paintRecents() {
    var group = $('[data-group="recent"]');
    if (!group) return;
    var holder = $('[data-recent-list]', group);
    var list = recents();
    holder.textContent = '';
    list.forEach(function (q) {
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'as-chip'; b.setAttribute('data-term', q); b.textContent = q;
      holder.appendChild(b);
    });
    group.hidden = list.length === 0;
  }
  paintRecents();

  /* Capture phase, so the typed words are saved before aagamstuti.js adds an occasion or turns an empty box into * */
  on(doc, 'submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[role="search"]') : null;
    if (!form) return;
    var q = $('input[name="q"]', form);
    if (q) remember(q.value);
    var flag = $('[data-instock-input]', form), chip = $('[data-instock]');
    if (flag) flag.disabled = !(chip && chip.getAttribute('aria-pressed') === 'true');
  }, true);

  on(doc, 'click', function (e) {
    if (e.target.closest('[data-search-open]')) { paintRecents(); return; }
    if (e.target.closest('[data-recent-clear]')) { store(RKEY, null); paintRecents(); return; }
    var stock = e.target.closest('[data-instock]');
    if (stock) { stock.setAttribute('aria-pressed', stock.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); return; }

    /* Filter bar: the In stock switch ticks the matching box in the filter form */
    var tog = e.target.closest('[data-quick-toggle]');
    if (tog) {
      var form = $('[data-filters-form]');
      var box = form && $('input[name="' + tog.getAttribute('data-param') + '"][value="' + tog.getAttribute('data-value') + '"]', form);
      if (!box || box.disabled) return;
      box.checked = !box.checked;
      box.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* Price bands fill the two price boxes */
    var band = e.target.closest('[data-band]');
    if (band) {
      var nums = $$('input[type="number"]', band.closest('.as-fgroup') || doc);
      if (nums.length < 2) return;
      var lo = band.getAttribute('data-min') || '', hi = band.getAttribute('data-max') || '';
      if (lo === '0') lo = '';
      var same = (nums[0].value || '') === lo && (nums[1].value || '') === hi;
      nums[0].value = same ? '' : lo;
      nums[1].value = same ? '' : hi;
      nums[1].dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Arrow keys between the search box and the suggestions ---------- */
  var input = $('[data-search-input]');
  var results = $('[data-search-results]');
  function links() {
    return $$('a[href]:not([tabindex="-1"])', results).filter(function (a) { return a.offsetParent !== null; });
  }
  on(input, 'keydown', function (e) {
    if (e.key !== 'ArrowDown') return;
    var all = links();
    if (all.length) { e.preventDefault(); all[0].focus(); }
  });
  on(results, 'keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var all = links(), i = all.indexOf(doc.activeElement);
    if (i < 0) return;
    e.preventDefault();
    if (e.key === 'ArrowDown') { if (i < all.length - 1) all[i + 1].focus(); }
    else if (i > 0) all[i - 1].focus();
    else if (input) input.focus();
  });

  /* ---------- One short announcement per set of suggestions, instead of reading the whole list out ---------- */
  var status = $('[data-search-status]');
  if (results && status && 'MutationObserver' in window) {
    var talk;
    new MutationObserver(function () {
      clearTimeout(talk);
      talk = setTimeout(function () {
        var n = links().length, typed = input && input.value.trim().length >= 2;
        status.textContent = !typed ? '' : n ? n + (n === 1 ? ' suggestion' : ' suggestions') + '. Press the down arrow to browse.' : 'No suggestions.';
      }, 400);
    }).observe(results, { childList: true });
  }

  /* ---------- Speed: fetch a page early when a pointer or finger lands on a product link ---------- */
  var seen = {}, used = 0;
  function early(e) {
    var a = e.target.closest ? e.target.closest('a.as-plate__link, .as-sidenav__row') : null;
    if (!a || used >= 8 || !a.href || seen[a.href] || a.origin !== location.origin) return;
    var net = navigator.connection;
    if (net && (net.saveData || /(^|-)2g$/.test(net.effectiveType || ''))) return;
    seen[a.href] = 1; used++;
    var link = doc.createElement('link');
    link.rel = 'prefetch'; link.href = a.href; link.as = 'document';
    doc.head.appendChild(link);
  }
  on(doc, 'mouseover', early, { passive: true });
  on(doc, 'touchstart', early, { passive: true });
})();